export default {
  labels: {
    order: 'Bestelling',
    customer: 'Klant',
  },
  tags: {
    new_customer: 'Nieuwe klant',
    loyal_customer: 'Vaste klant',
  },
};
